/** Field and button styles shared by the `/login` card and its lazy password-reset panel. */
export const inputClassName =
  'w-full rounded-lg border border-black/15 bg-white px-3 py-2.5 text-base text-ink shadow-sm focus:border-coral focus:outline-none focus:ring-2 focus:ring-coral/15 md:text-sm';
export const labelClassName = 'block text-sm font-bold text-ink';
export const primaryButtonClassName =
  'mt-1 flex h-11 w-full items-center justify-center rounded-full bg-coral text-sm font-bold text-white shadow-sm transition hover:bg-coral/90 disabled:cursor-not-allowed disabled:opacity-60 sm:gap-2 sm:px-2';
